import slugify from 'slugify';

import type { Thread } from 'src/mapper/threadMapper';

export const restoreFromSlug = (slug: string) => {
  // Replace hyphens with spaces
  let restoredText = slug.replace(/-/g, ' ');

  // Capitalize the first letter of each word
  restoredText = restoredText.replace(/\b\w/g, (char) => char.toUpperCase());

  return restoredText;
};

export const convertToSlug = (text: string) => slugify(text, { lower: true });

export const convertThreadToSlug = (title: string) =>
  slugify(title, {
    lower: true,
    strict: true,
  });

export const slugSubstring = (text: string, addDots = false): string => {
  let result = text.substring(0, 60);
  if (addDots) {
    result += text.length > 60 ? '...' : '';
  }
  return result;
};

export const parseHttpLinks = (text: string, disableLinks?: boolean) => {
  const words = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

  return text.split(words).map((part) => {
    if (
      part.startsWith('http') ||
      part.startsWith('https') ||
      part.startsWith('www.')
    ) {
      return { type: 'link', value: part, disableLinks };
    }
    return { type: 'text', value: part };
  });
};

// TODO :: remove this function when backend is ready returning thread slug
export const formattingThreadSlug = (slug?: string | null, id: string = '') => {
  if (!slug) return id;
  const [threadId, threadSlug] = slug.split('/');
  return threadId && threadSlug ? `${threadSlug}-${threadId}` : id;
};

export const getThreadTitle = ({ title = '' }: Thread) =>
  slugSubstring(title, true) || 'Thread';
